import React from "react";

const AboutMe = () => {
  const calculateAge = (birthDate) => {
    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birth.getDate())
    ) {
      age--;
    }

    return age;
  };

  const age = calculateAge("2002-10-05");

  return (
    <div className="flex flex-col md:flex-row pb-6">
      <div className="w-full md:w-1/2 text-zinc-400 px-6 border-r-[1px] border-r-zinc-600 flex items-center">
        <div className="py-6">
          <h2 className="font-semibold mb-1">Hey! I'm Abdul Fikih Kurnia</h2>
          <p className="text-base leading-6 ">
            Experienced IT professional with expertise in Software Development,
            Web Technologies (JavaScript, TypeScript, Angular, Laravel,
            Next.js), Cybersecurity (ISO, NIST), IT Infrastructure, Data
            Analyst, IoT, and AI/ML solutions. Skilled in creating scalable
            applications and leveraging innovative technologies to optimize
            performance and drive impactful results. Committed to continuous
            learning and effective collaboration{" "}
          </p>
        </div>
      </div>
      <div className="w-full md:w-1/2 p-6">
        <ul className="flex flex-col gap-1">
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Age:</span>
            {age}
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Residence:</span>
            Indonesia
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Freelance:</span>
            Available
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Address:</span>
            Jakarta, Indonesia
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Founder:</span>
            <a
              href="https://paramitha.tech"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:underline"
            >
              Paramitha Solutions
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AboutMe;
